export default "__VITE_ASSET__C50AUGUd__"